export interface GetGridHeadersRequest {
  entityType: number;
}
